export default __webpack_public_path__ + "static/media/amazon.418bf4ac.svg";